import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-embeded-reports',
  templateUrl: './embeded-reports.component.html',
  styleUrls: ['./embeded-reports.component.scss']
})
export class EmbededReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
